import { configureStore } from '@reduxjs/toolkit';

import { authenticationSlice } from './slices/authentication';

import certificationReducer from './slices/certification/certificationSilce';

export * from './slices/authorization/user.role.slice';

export const store = configureStore({
    reducer: {
        authentication: authenticationSlice.reducer,
        certificationReducer: certificationReducer
    },
});